import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import Dashboard from './Dashboard';
import GreenbackAIChat from './ai/GreenbackAIChat';
import { MenuIcon, XIcon } from 'lucide-react';
interface LayoutProps {
  children?: React.ReactNode;
}
const Layout: React.FC<LayoutProps> = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isAIChatOpen, setIsAIChatOpen] = useState(false);
  return <>
      <div className="flex h-screen bg-gray-100" data-id="element-1848">
        {/* Mobile sidebar */}
        <div className={`fixed inset-0 z-40 md:hidden ${sidebarOpen ? 'block' : 'hidden'}`} data-id="element-1849">
          {/* Sidebar backdrop */}
          <div className="fixed inset-0 bg-gray-600 bg-opacity-75" onClick={() => setSidebarOpen(false)} data-id="element-1850"></div>
          {/* Sidebar */}
          <div className="relative flex-1 flex flex-col w-2/3 h-full bg-black overflow-hidden" data-id="element-1851">
            <div className="absolute top-0 right-0 -mr-12 pt-2" data-id="element-1852">
              <button type="button" className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white" onClick={() => setSidebarOpen(false)} data-id="element-1853">
                <span className="sr-only" data-id="element-1854">Close sidebar</span>
                <XIcon className="h-6 w-6 text-white" aria-hidden="true" data-id="element-1855" />
              </button>
            </div>
            <div className="flex-1 h-full overflow-y-auto" data-id="element-1856">
              <Sidebar activePage="formazione" data-id="element-1857" />
            </div>
          </div>
        </div>
        {/* Static sidebar for desktop */}
        <div className="hidden md:flex md:flex-shrink-0" data-id="element-1858">
          <Sidebar activePage="formazione" data-id="element-1859" />
        </div>
        <div className="flex flex-col flex-1 overflow-hidden" data-id="element-1860">
          <Topbar onMenuClick={() => setSidebarOpen(true)} onOpenAIChat={() => setIsAIChatOpen(true)} data-id="element-1861" />
          <main className="flex-1 overflow-y-auto p-4 md:p-6 pt-0 md:pt-0 bg-gray-100" data-id="element-1862">
            <div className="pt-4 md:pt-6" data-id="element-1863">
              <Dashboard data-id="element-1864" />
            </div>
          </main>
        </div>
      </div>

      {/* AI Chat Interface */}
      <GreenbackAIChat isOpen={isAIChatOpen} onClose={() => setIsAIChatOpen(false)} data-id="element-1865" />
    </>;
};
export default Layout;